var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"building3DModel"},[_vm._v("3D模型")])
}
var staticRenderFns = []

export { render, staticRenderFns }